import { BRAND_LIST } from 'typings'
import * as Typings from '../typings'

const HonkKongLocale: Typings.LocaleType = {
  REGION: Typings.RegionGroupNames.ASIA,
  CODE: 'hk',
  LANGUAGE_CODE: 'zh',

  LONG_NAME: 'Honk Kong',
  SHORT_NAME: 'HK',

  DISPLAY_NAME: '香港',
  DISPLAY_COUNTRY: '香港',

  LANGUAGES: {
    ZH: 'zh',
  },

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 33.92920123358008,
    INITIAL_LONGITUDE: 138.42930714999994,
    INITIAL_ZOOM: 4,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  AREAS: {},

  HOME_PAGE_URL: 'https://www.uniqlo.com',

  MAP_URL: 'https://www.uniqlo.com.hk/pc/zh_HK/shop/shop_list.html',
  MAP_MOBILE_URL: 'https://m.uniqlo.com.hk/#/store_entrance',

  TERMS_OF_USE_URL: 'https://www.uniqlo.com',
  PRIVACY_POLICY_URL: 'https://www.uniqlo.com',

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },

  AM_FORMAT: ' AM',
  PM_FORMAT: ' PM',
}

export default HonkKongLocale
